// src/components/Testimonials.jsx
import Reveal from "./Reveal";

/* ---------- Small avatar with fallback initials ---------- */
function Avatar({ name, src }) {
  const initials = name
    .split(" ")
    .map((n) => n[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <div className="relative shrink-0">
      {src ? (
        <img
          src={src}
          alt={name}
          className="h-8 w-8 rounded-full object-cover ring-2 ring-white"
          loading="lazy"
        />
      ) : (
        <div className="h-8 w-8 rounded-full bg-gradient-to-b from-[#E8D9B6] to-[#D9C597] text-[#0A2540] grid place-items-center text-[11px] font-bold ring-2 ring-white">
          {initials}
        </div>
      )}

      {/* tiny verified tick */}
      <span className="absolute -bottom-0.5 -right-0.5 grid h-3.5 w-3.5 place-items-center rounded-full bg-emerald-500 text-[10px] text-white ring-2 ring-white">
        ✓
      </span>
    </div>
  );
}

export default function Testimonials() {
  const items = [
    {
      quote: "They made the process simple and kept me updated.",
      name: "Sarah T.",
      location: "Phoenix, AZ",
      avatar: "https://randomuser.me/api/portraits/women/68.jpg", // optional; falls back to initials if missing
    },
    {
      quote: "Professional, compassionate, and they got results.",
      name: "James P.",
      location: "Dallas, TX",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      quote: "From Linda, Thank you for fighting for our family’s justice.",
      name: "Linda M.",
      location: "Orlando, FL",
      avatar: "https://randomuser.me/api/portraits/women/65.jpg",
    },
  ];

  return (
    <section
      id="testimonials"
      className="relative overflow-hidden py-16 md:py-20"
    >
      {/* Left & right reflections (identical, full height, desktop only) */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-0 hidden md:block
                   w-32 opacity-70 mix-blend-multiply z-0
                   bg-gradient-to-r from-[#0A2540]/10 via-[#0A2540]/5 to-transparent"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 right-0 hidden md:block
                   w-32 opacity-70 mix-blend-multiply z-0
                   bg-gradient-to-l from-[#0A2540]/10 via-[#0A2540]/5 to-transparent"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4">
        <div className="mb-8 md:mb-10">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A2540]">
            Success Stories
          </h2>
          <p className="text-slate-600 mt-1">
            These testimonials reflect real client experiences working with our
            network of attorneys. Every case is unique and results can vary, but
            our process stays the same: clear updates, respectful guidance, and
            no fees unless there’s a recovery. We protect your privacy and keep
            details confidential. Start with a quick, free review—no obligation
            and no upfront costs.
          </p>
        </div>

        {/* Grid: swipeable on mobile, 3-up on desktop */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-7">
          {/* Mobile horizontal scroll container */}
          <div className="md:contents -mx-4 md:mx-0 overflow-x-auto md:overflow-visible snap-x snap-mandatory pb-2 md:pb-0">
            <div className="md:contents flex md:block gap-4 px-4 md:px-0">
              {items.map((t, i) => (
                <Reveal key={i} delay={i * 120} className="md:contents">
                  <article
                    className="
                      snap-start md:snap-none min-w-[84%] md:min-w-0
                      bg-[#FBF9F4] rounded-2xl border border-[#EADDC2]
                      p-6 md:p-7 text-[#0A2540]
                      shadow-[0_10px_30px_rgba(0,0,0,0.06)]
                      transition-all duration-300
                      hover:-translate-y-1.5 hover:border-[#C89B3C]
                      hover:ring-2 hover:ring-[#C89B3C]/20
                    "
                  >
                    {/* gold quote accent */}
                    <div className="text-[#C89B3C] text-2xl leading-none mb-3">
                      “
                    </div>

                    <p className="text-slate-800">{t.quote}</p>

                    <div className="mt-5 flex items-center gap-3">
                      <Avatar name={t.name} src={t.avatar} />
                      <div>
                        <div className="text-sm font-semibold text-[#0A2540]">
                          {t.name}
                        </div>
                        <div className="text-xs text-slate-500">
                          {t.location}
                        </div>
                      </div>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
